"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ProjectTypes_1 = require("Project/ProjectTypes");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SearchResultCard = (function (_super) {
    __extends(SearchResultCard, _super);
    function SearchResultCard(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseLeave = function () {
            if (_this.props.onMouseLeave) {
                _this.props.onMouseLeave();
            }
        };
        _this.onOptionMenuClick = function (event) {
            event.stopPropagation();
            _this.props.onOptionButtonClick();
        };
        _this.containerRef = react_1.default.createRef();
        return _this;
    }
    SearchResultCard.prototype.render = function () {
        var _a = this.props, name = _a.name, highlight = _a.highlight;
        var statusRow = this.getStatusRow();
        var nameHtml = highlight.name && highlight.name.length > 0 ? highlight.name[0] : name;
        var highlightHtml = highlight.blockContents && highlight.blockContents.length > 0 ? "\u201C... ".concat(highlight.blockContents[0]) : "";
        var optionButton = this.renderOptionButton();
        return (react_1.default.createElement("div", { className: "search-card", onClick: this.handleOnClick, onMouseLeave: this.onMouseLeave },
            react_1.default.createElement("div", { className: "search-card__left" },
                statusRow,
                react_1.default.createElement("div", { className: "search-card__name", dangerouslySetInnerHTML: { __html: nameHtml } }),
                highlightHtml && (react_1.default.createElement("div", { className: "search-card__match-container" },
                    react_1.default.createElement("div", { className: "search-card__match", dangerouslySetInnerHTML: { __html: highlightHtml } })))),
            react_1.default.createElement("div", { className: "search-card__right" }, optionButton)));
    };
    SearchResultCard.prototype.handleOnClick = function (event) {
        event.stopPropagation();
        if (event.ctrlKey || event.metaKey) {
            window.open("/#/page/".concat(this.props.id), "_blank");
        }
        else {
            this.props.openProject();
        }
    };
    SearchResultCard.prototype.handlePreviewClick = function (event) {
        event.stopPropagation();
        this.props.previewProject();
    };
    SearchResultCard.prototype.handleEditClick = function (event) {
        event.stopPropagation();
        this.props.editProject();
    };
    SearchResultCard.prototype.handleCloneClick = function (event) {
        event.stopPropagation();
        this.props.cloneProject();
    };
    SearchResultCard.prototype.handleViewChildrenClick = function (event) {
        event.stopPropagation();
        this.props.onViewChildren();
    };
    SearchResultCard.prototype.getStatusRow = function () {
        var statusText = this.props.hasTemplateChildren ? "blueprint" : this.props.status;
        var classes = (0, classnames_1.default)("search-card__status", {
            "search-card__status--accepted": statusText == ProjectTypes_1.ProjectSearchResultStatus.Accepted,
            "search-card__status--live": statusText == ProjectTypes_1.ProjectSearchResultStatus.Live,
            "search-card__status--archived": statusText == ProjectTypes_1.ProjectSearchResultStatus.Archived,
            "search-card__status--draft": statusText == ProjectTypes_1.ProjectSearchResultStatus.Draft,
            "search-card__status--pending": statusText == ProjectTypes_1.ProjectSearchResultStatus.Pending,
            "search-card__status--blueprint": statusText === "blueprint",
        });
        var statusIcon;
        switch (statusText) {
            case ProjectTypes_1.ProjectSearchResultStatus.Accepted:
                statusIcon = react_1.default.createElement(icons_1.Tick, { size: icons_1.IconSize.Small });
                break;
            case ProjectTypes_1.ProjectSearchResultStatus.Archived:
                statusIcon = react_1.default.createElement(icons_1.Archive, { size: icons_1.IconSize.Small });
                break;
            case ProjectTypes_1.ProjectSearchResultStatus.Live:
            case ProjectTypes_1.ProjectSearchResultStatus.Draft:
            case ProjectTypes_1.ProjectSearchResultStatus.Pending:
            case "blueprint":
                statusIcon = react_1.default.createElement(icons_1.ListMarkerCircle, { size: icons_1.IconSize.Small });
        }
        return (react_1.default.createElement("div", { className: classes },
            react_1.default.createElement("div", { className: "search-card__icon-wrapper" }, statusIcon),
            react_1.default.createElement("div", { className: "search-card__status-text" }, statusText),
            this.props.templateParent && react_1.default.createElement("div", { className: "search-card__blueprint-child-text" }, "\u00A0| blueprint child")));
    };
    SearchResultCard.prototype.renderOptionButton = function () {
        var _a;
        return (react_1.default.createElement("div", { ref: this.containerRef, className: (0, classnames_1.default)("search-card__option-button", (_a = {},
                _a["search-card__option-button--active"] = this.props.isShowingOptions,
                _a)) }, this.renderOptionMenu(this.props.isShowingOptions)));
    };
    Object.defineProperty(SearchResultCard.prototype, "isDisabled", {
        get: function () {
            return this.props.status === ProjectTypes_1.ProjectSearchResultStatus.Accepted;
        },
        enumerable: false,
        configurable: true
    });
    SearchResultCard.prototype.renderOptionMenu = function (isShowingOptions) {
        if (isShowingOptions === void 0) { isShowingOptions = false; }
        var optionMenuItems = this.props.hasTemplateChildren ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { disabled: this.isDisabled, onClick: this.handleEditClick }, "Edit"),
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: this.handleViewChildrenClick }, "View children"))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { disabled: this.isDisabled, onClick: this.handleEditClick }, "Edit"),
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: this.handleCloneClick }, "Clone"),
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: this.handlePreviewClick }, "Preview")));
        return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: "search-card__option-menu", isOpen: isShowingOptions, onClose: this.props.onOptionMenuClose, button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null), onClick: this.onOptionMenuClick, size: kaleidoscope_1.ButtonSize.Small }) }, optionMenuItems));
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.MouseEvent) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], SearchResultCard.prototype, "handleOnClick", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof react_1.default !== "undefined" && react_1.default.MouseEvent) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], SearchResultCard.prototype, "handlePreviewClick", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof react_1.default !== "undefined" && react_1.default.MouseEvent) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], SearchResultCard.prototype, "handleEditClick", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof react_1.default !== "undefined" && react_1.default.MouseEvent) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], SearchResultCard.prototype, "handleCloneClick", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof react_1.default !== "undefined" && react_1.default.MouseEvent) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], SearchResultCard.prototype, "handleViewChildrenClick", null);
    SearchResultCard = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SearchResultCard);
    return SearchResultCard;
}(react_1.default.Component));
exports.default = SearchResultCard;
